export const MS_ERROR_TEXT =
  'Oops! Something went wrong. Please let your teacher know.';
